import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesOverview from "@/pages/ServicesOverview";
import ServiceDetail from "@/pages/ServiceDetail";
import Remediation from "@/pages/Remediation";
import Portfolio from "@/pages/Portfolio";
import CaseStudy from "@/pages/CaseStudy";
import About from "@/pages/About";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App font-body antialiased">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesOverview />} />
            <Route path="/services/microcement" element={<ServiceDetail slug="microcement" />} />
            <Route path="/services/rendering" element={<ServiceDetail slug="rendering" />} />
            <Route path="/services/plastering" element={<ServiceDetail slug="plastering" />} />
            <Route path="/services/waterproofing" element={<ServiceDetail slug="waterproofing" />} />
            <Route path="/services/remediation" element={<Remediation />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:id" element={<CaseStudy />} />
            <Route path="/about" element={<About />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
